
import './App.css'; // Import CSS file for additional styling if needed
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
// import "bootstrap-icons/font/bootstrap-icons.css";
import Navbar2 from './components/Navbar2';

import React,{useEffect} from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Products1 from './pages/Products1';
import Contactus1 from './pages/Contactus1';
import Dealership from './pages/Dealership';


function App() {
  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);
  return (


    <Router>
    <div className="App" >
      <Navbar2 />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About/>} />
        <Route path="/products" element={<Products1/>} />
        <Route path='/dealership' element={<Dealership/>}/>
        <Route path="/contact" element={<Contactus1/>} />
      </Routes>
    </div>
  </Router>
  );
}

export default App;

